import React from "react";
import styled from "styled-components";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

export default function ERP_Dashboard() {
  const revenueData = {
    labels: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    datasets: [
      {
        label: "Total Revenue",
        data: [65, 80, 20, 70, 60, 85, 40, 15, 10, 5, 30, 80],
        borderColor: "#007bff",
        backgroundColor: "rgba(0,123,255,0.1)",
        tension: 0.4,
        pointRadius: 4,
      },
    ],
  };

  return (
    <Wrapper>
      <MainContent>
        <Header>
          <h2>Dashboard</h2>
          <UserInfo>Good Morning, Alan</UserInfo>
        </Header>

        <CardRow>
          <Card>
            <CardTitle>Total Orders</CardTitle>
            <CardValue>0.00</CardValue>
            <CardSub>0.00 LKS/Avg Orders</CardSub>
          </Card>
          <Card>
            <CardTitle>Total Customers</CardTitle>
            <CardValue>0.00</CardValue>
            <CardSub>0.00 LKS/Avg Customers</CardSub>
          </Card>
        </CardRow>

        <TwoColumn>
          <Left>
            <Table>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Total (LKS)</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>Item Sales</td><td>00</td></tr>
                <tr><td>Refunds</td><td>00</td></tr>
                <tr><td>Net Sales</td><td>00</td></tr>
                <tr><td>Tax</td><td>00</td></tr>
                <tr><td>Gross Sales</td><td>00</td></tr>
                <tr><td>Fees</td><td>00</td></tr>
                <tr><td><b>Total Sales</b></td><td><b>00</b></td></tr>
              </tbody>
            </Table>
          </Left>

          <Right>
            <ChartContainer>
              <h4>Revenue</h4>
              <Line data={revenueData} />
            </ChartContainer>
          </Right>
        </TwoColumn>

        <BottomReports>
          <ReportCard>Sale Report</ReportCard>
          <ReportCard>All Transactions</ReportCard>
          <ReportCard>Daybook Report</ReportCard>
          <ReportCard>Party Statement</ReportCard>
        </BottomReports>
      </MainContent>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: white;
  min-height: 100vh;
  font-family: sans-serif;
`;

const MainContent = styled.div`
  padding: 20px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const UserInfo = styled.div`
  font-size: 14px;
  color: #555;
`;

const CardRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
`;

const Card = styled.div`
  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 20px;
  flex: 1;
  text-align: center;
`;

const CardTitle = styled.div`
  font-size: 14px;
  color: #666;
`;

const CardValue = styled.div`
  font-size: 26px;
  font-weight: bold;
  margin-top: 8px;
`;

const CardSub = styled.div`
  font-size: 12px;
  color: #999;
`;

const TwoColumn = styled.div`
  display: flex;
  gap: 20px;
`;

const Left = styled.div`
  flex: 1;
`;

const Right = styled.div`
  flex: 1;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  th, td {
    border-bottom: 1px solid #eee;
    padding: 10px;
    text-align: left;
  }
  th {
    background: #fafafa;
    font-size: 14px;
    color: #333;
  }
`;

const ChartContainer = styled.div`
  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 20px;
`;

const BottomReports = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 30px;
`;

const ReportCard = styled.div`
  flex: 1;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  text-align: center;
  cursor: pointer;
  font-weight: bold;
  color: #007bff;
  transition: all 0.2s;
  &:hover {
    background: #f0f8ff;
  }
`;
